var _rect, _rect2, _g, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewCollaborator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_395_26897",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 5,
    width: 20,
    height: 18
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 20,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_395_26897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.83331 20.8001V18.4288C4.83331 17.9489 4.95484 17.5079 5.1979 17.1056C5.44095 16.7033 5.76387 16.3963 6.16665 16.1846C7.02776 15.747 7.90276 15.4189 8.79165 15.2001C9.68054 14.9813 10.5833 14.8719 11.5 14.8719C12.4166 14.8719 13.3194 14.9813 14.2083 15.2001C15.0972 15.4189 15.9722 15.747 16.8333 16.1846C17.2361 16.3963 17.559 16.7033 17.8021 17.1056C18.0451 17.5079 18.1666 17.9489 18.1666 18.4288V20.8001H4.83331ZM19.8333 20.8001V18.2595C19.8333 17.6384 19.6632 17.0421 19.3229 16.4704C18.9826 15.8988 18.5 15.4083 17.875 14.999C18.5833 15.0837 19.25 15.2283 19.875 15.433C20.5 15.6377 21.0833 15.8882 21.625 16.1846C22.125 16.4669 22.5069 16.781 22.7708 17.1268C23.0347 17.4726 23.1666 17.8501 23.1666 18.2595V20.8001H19.8333ZM11.5 14.0251C10.5833 14.0251 9.79859 13.6934 9.14581 13.03C8.49304 12.3666 8.16665 11.5691 8.16665 10.6375C8.16665 9.70596 8.49304 8.90848 9.14581 8.24509C9.79859 7.5817 10.5833 7.25 11.5 7.25C12.4166 7.25 13.2014 7.5817 13.8541 8.24509C14.5069 8.90848 14.8333 9.70596 14.8333 10.6375C14.8333 11.5691 14.5069 12.3666 13.8541 13.03C13.2014 13.6934 12.4166 14.0251 11.5 14.0251ZM19.8333 10.6375C19.8333 11.5691 19.5069 12.3666 18.8541 13.03C18.2014 13.6934 17.4166 14.0251 16.5 14.0251C16.3472 14.0251 16.1528 14.0074 15.9166 13.9721C15.6805 13.9368 15.4861 13.898 15.3333 13.8557C15.7083 13.404 15.9965 12.9029 16.1979 12.3525C16.3993 11.802 16.5 11.2303 16.5 10.6375C16.5 10.0447 16.3993 9.47307 16.1979 8.92259C15.9965 8.37212 15.7083 7.87105 15.3333 7.41938C15.5278 7.3488 15.7222 7.30293 15.9166 7.28176C16.1111 7.26059 16.3055 7.25 16.5 7.25C17.4166 7.25 18.2014 7.5817 18.8541 8.24509C19.5069 8.90848 19.8333 9.70596 19.8333 10.6375ZM6.49998 19.1063H16.5V18.4288C16.5 18.2736 16.4618 18.1324 16.3854 18.0054C16.309 17.8784 16.2083 17.7796 16.0833 17.709C15.3333 17.3279 14.5764 17.0421 13.8125 16.8515C13.0486 16.661 12.2778 16.5657 11.5 16.5657C10.7222 16.5657 9.95137 16.661 9.18748 16.8515C8.42359 17.0421 7.66665 17.3279 6.91665 17.709C6.79165 17.7796 6.69095 17.8784 6.61456 18.0054C6.53817 18.1324 6.49998 18.2736 6.49998 18.4288V19.1063ZM11.5 12.3313C11.9583 12.3313 12.3507 12.1654 12.6771 11.8337C13.0035 11.5021 13.1666 11.1033 13.1666 10.6375C13.1666 10.1717 13.0035 9.773 12.6771 9.44131C12.3507 9.10961 11.9583 8.94376 11.5 8.94376C11.0416 8.94376 10.6493 9.10961 10.3229 9.44131C9.99651 9.773 9.83331 10.1717 9.83331 10.6375C9.83331 11.1033 9.99651 11.5021 10.3229 11.8337C10.6493 12.1654 11.0416 12.3313 11.5 12.3313Z",
    fill: "#1C1B1F"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#FFDF0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCollaborator);
export default __webpack_public_path__ + "static/media/new_collaborator.133ac065d85c2b3e928057001650734a.svg";
export { ForwardRef as ReactComponent };